// extracted by mini-css-extract-plugin
export default {"root":"Help_root__aqyXj","item":"Help_item__3_XJt","image":"Help_image__3XCCh","title":"Help_title__1y_6R","copy":"Help_copy__17-A5"};